<template>
  <div>
    <van-nav-bar
      fixed
      title="调拨单详情"
      left-arrow
      @click-left="onClickLeft"
    />

    <div id="aaa"></div>

    <van-cell-group title="调出中心" :border="false" style="margin-left: 10px">
      <van-cell
        icon="location-o"
        :title="currentAgentName"
        style="border-bottom: 0.1px solid #f5f5f5"
      />
    </van-cell-group>

    <van-cell-group title="调入中心" :border="false" style="margin-left: 10px">
      <van-cell
        icon="location-o"
        :title="receiverName"
        style="border-bottom: 0.1px solid #f5f5f5"
      />
    </van-cell-group>

    <van-cell-group title="备注" :border="false">
      <van-cell icon="edit" style="border-bottom: 0.1px solid #f5f5f5">
        <van-field
          v-model="message"
          :disabled="!isFirstNode || !permission"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="调拨申请"
          show-word-limit
        />
      </van-cell>
    </van-cell-group>

    <van-cell-group title="调拨明细" :border="false">
      <van-cell class="box">
        <van-swipe-cell v-for="(item, index) in allotDetail" :key="index">
          <van-cell-group :border="false">
            <van-cell class="detailcell">
              <van-row class="ha" type="flex" justify="space-between">
                <van-col span="22">
                  <span style="#323233!important">型号</span>
                  {{ item.modelname }}
                </van-col>
              </van-row>
              <van-row type="flex">
                <van-col span="24">
                  <span style="color: #969799">库存数量:</span>
                  {{ item.quantity + item.unit }}
                </van-col>
              </van-row>
              <van-row type="flex" justify="space-between">
                <van-col span="20">
                  <span style="color: #969799">调出数量:</span>
                  <input
                    type="text"
                    style="width: 70%; border: none"
                    :disabled="!isFirstNode || !permission"
                    v-model="item.count"
                  />
                </van-col>
                <!--<van-col span="4"><van-image round width="0.8rem" height="0.8rem" src="/img/del.png" @click="del(index)"/></van-col>-->
              </van-row>
              <van-row type="flex">
                <van-col span="24">
                  <span style="color: #969799">调入仓库:</span>
                  <van-tag
                    plain
                    type="danger"
                    size="large"
                    color="#838683"
                    text-color="#838683"
                    v-for="(warehousenam, warehouseind) in receiverWarehouse"
                    :key="warehouseind"
                    round
                    :class="{
                      selected: warehousenam.id == item.warehouseselected,
                    }"
                    @click="toggleDetSel(warehousenam.id, index)"
                    >{{ warehousenam.warehouse_name }}</van-tag
                  >
                </van-col>
              </van-row>
            </van-cell>
          </van-cell-group>
          <van-button
            style="height: 100%"
            slot="right"
            square
            text="删除"
            type="danger"
            class="delete-button"
            @click="del(index)"
          />
        </van-swipe-cell>
      </van-cell>
      <van-cell v-if="isFirstNode">
        <van-icon
          name="add-o"
          color="#07c160"
          size="40"
          @click="add"
          style="float: right"
        />
      </van-cell>
    </van-cell-group>

    <van-cell-group v-if="permission">
      <van-cell>
        <van-row type="flex">
          <van-col span="10">
            <van-button round type="info" @click="tijiao">提交</van-button>
          </van-col>
          <van-col span="2"></van-col>
          <van-col span="10">
            <van-button round type="info" @click="tuihui">退回</van-button>
          </van-col>
        </van-row>
      </van-cell>
    </van-cell-group>

    <div
      v-show="bottom_tip"
      style="font-size: 10px; text-align: center; padding: 10px 10px"
    >
      ©2020 一脉阳光集团信息中心
    </div>
    <van-dialog
      v-model="show"
      title="请仔细核查"
      show-cancel-button
      @confirm="qrtj"
    >
      <van-cell-group title="影像中心" :border="false">
        <van-cell :title="currentAgentName" />
      </van-cell-group>
      <van-cell-group title="调拨明细" :border="false">
        <van-cell v-for="(item, index) in allotDetail" :key="index">
          <van-row type="flex">
            <van-col span="6">耗材型号：</van-col>
            <van-col span="18">{{ item.modelname }}</van-col>
          </van-row>
          <van-row type="flex">
            <van-col span="6">调出数量：</van-col>
            <van-col span="18">{{ item.count }}</van-col>
          </van-row>
        </van-cell>
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import {
  SwipeCell,
  NavBar,
  Tag,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
  Panel,
  Divider,
  Button,
  Dialog,
  Icon,
  Image,
  Toast,
} from "vant";
import { mapState } from "vuex";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Panel.name]: Panel,
    [Divider.name]: Divider,
    [Row.name]: Row,
    [SwipeCell.name]: SwipeCell,
  },
  data() {
    return {
      currentAgent: "",
      show: false,
      message: "",
      bottom_tip: true,
      currentAgentErp: "",
      currentAgentName: "",
      currentAgentWarehouse: [],
      receiverName: "",
      receiverErp: "",
      receiverWarehouse: [],
      allotDetail: [],
      currentnode: "",
      mainid: "",
      permission:'',
      isFirstNode:'',
    };
  },
  methods: {
    toggleDetSel(index, ind) {
      this.allotDetail[ind].warehouseselected = index;
      this.$forceUpdate();
    },
    onClickLeft() {
      this.$router.push({
        name: "allot",
        query: {
          ms: this.$route.query.ms,
          node: this.$route.query.node,
          isall: this.$route.query.isall,
        },
      });
    },

    parseSubmitData(obj) {
      let newarr = [];
      let message = "";
      for (let i = 0; i < obj.length; i++) {
        if (!obj[i].count || obj[i].count == 0) {
          let num = i + 1;
          message = message + "第" + num + "条明细,调出数量为空或0\n";
        }
        if (
          obj[i].count &&
          obj[i].count > obj[i].quantity &&
          obj[i].count != 0 &&
          !obj[i].count.match(/\D/g)
        ) {
          let num = i + 1;
          message =
            message + "第" + num + "条明细,调出数量不能超过库存数量！\n";
        }
        if (!obj[i].warehouseselected) {
          let num = i + 1;
          message = message + "第" + num + "条明细,未选择调入仓库！\n";
        }
        let newobj = {
          transfer_id: obj[i].transfer_id,
          stock_id: obj[i].id,
          warehouse_id: obj[i].warehouseselected,
          brand_uuid: obj[i].brand_uuid,
          model_uuid: obj[i].model_uuid,
          unit: obj[i].unit,
          unitcost: obj[i].unit_cost,
          quantity: obj[i].count,
        };
        newarr.push(newobj);
      }
      return {
        message: message,
        data: newarr,
      };
    },
    formatData(obj) {
      let newarr = [];
      for (let i = 0; i < obj.length; i++) {
        let newobj = {
          transfer_id: obj[i].id,
          id: obj[i].stock_id,
          warehouseselected: obj[i].warehouse_id,
          brand_uuid: obj[i].brand_uuid,
          model_uuid: obj[i].model_uuid,
          unit: obj[i].unit,
          unit_cost: obj[i].tax_unit_price,
          quantity: obj[i].stock_quantity,
          count: obj[i].quantity,
          modelname: obj[i].model_name,
        };
        newarr.push(newobj);
      }
      return newarr;
    },
    tijiao() {
      this.show = true;
    },
    tuihui() {
      let that = this;
      let data = {
        mainid: this.mainid,
        creater: localStorage.getItem("usermobile"),
        remark: this.message ? this.message : "",
        currentnode: this.currentnode,
        projectErpCodeOut: this.currentAgentErp,
        projectErpCodeIn: this.receiverErp,
      };
      this.$http({
        method: "post",
        url: "/mobile/transfer/returnNode",
        data,
      }).then(function (response) {
        if (response.state == 200) {
          Toast.success("退回成功");
          //window.console.log(response);
          that.$router.push("allot");
        }
      });
    },
    qrtj() {
      let that = this;
      if (!this.allotDetail[0]) {
        Toast("明细不能为空");
        return;
      }
      let result = this.parseSubmitData(this.allotDetail);
      // window.console.log(result);
      if (result.message) {
        Toast(result.message);
        return;
      } else {
        let data = {
          mainid: this.mainid,
          projectErpCodeOut: this.currentAgentErp,
          projectErpCodeIn: this.receiverErp,
          creater: localStorage.getItem("usermobile"),
          remark: this.message ? this.message : "调拨申请",
          currentnode: this.currentnode,
          detail: result.data,
        };
        //window.console.log(data);
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        //window.console.log(data);
        this.$http({
          method: "post",
          url: "/mobile/transfer/submitNode",
          data,
        }).then(function (response) {
          if (response.state == 200) {
            Toast.success("提交成功");
            //window.console.log(response);
            that.$router.push("allot");
          }
        });
      }
    },
    del(index) {
      this.allotDetail.splice(index, 1);
    },
    add() {
      let extra = {
        message: this.message,
        currentAgentErp: this.currentAgentErp,
        currentAgentName: this.currentAgentName,
        currentAgentWarehouse: this.currentAgentWarehouse,
        receiverErp: this.receiverErp,
        receiverName: this.receiverName,
        receiverWarehouse: this.receiverWarehouse,
        currentnode: this.currentnode,
        mainid: this.mainid,
        permission: this.permission,
        isFirstNode: this.isFirstNode,
      };
      this.$router.push({
        name: "stockdetail",
        params: {
          from: "allotdetail",
          projectErpCode: this.currentAgentErp,
          warehouse: this.currentAgentWarehouse,
          container: this.allotDetail,
          extra,
        },
      });
    },
  },
  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
  },
  created() {
    let _this = this;
    this.currentAgent = this.permissionAgent.find(function (item) {
      return item.id == _this.defaultAgentIndex;
    });
    if (this.$route.query.id) {
      this.mainid = this.$route.query.id;
      this.$http
        .post("/mobile/transfer/detailList", {
          mainid: this.mainid,
          mobile: localStorage.getItem("usermobile"),
        })
        .then(function (response) {
          _this.currentAgentErp = response.record.main.transfer_out_project;
          _this.currentAgentName =
            response.record.main.transfer_out_project_name;
          _this.currentAgentWarehouse = response.out_project_warehouse;
          _this.receiverName = response.record.main.transfer_in_project_name;
          _this.receiverErp = response.record.main.transfer_in_project;
          _this.currentnode = response.record.main.currentnode;
          _this.receiverWarehouse = response.in_project_warehouse;
          _this.permission = response.permission;
          _this.isFirstNode = response.is_first_node;
          _this.message = response.record.main.remark;
          _this.allotDetail = _this.formatData(response.record.detail);
        });
    } else {
      this.message = this.$route.params.extra.message;
      this.allotDetail = this.$route.params.container;
      this.currentAgentErp = this.$route.params.extra.currentAgentErp;
      this.currentAgentName = this.$route.params.extra.currentAgentName;
      this.currentAgentWarehouse =
        this.$route.params.extra.currentAgentWarehouse;
      this.receiverErp = this.$route.params.extra.receiverErp;
      this.receiverName = this.$route.params.extra.receiverName;
      this.receiverWarehouse = this.$route.params.extra.receiverWarehouse;
      this.currentnode = this.$route.params.extra.currentnode;
      this.mainid = this.$route.params.extra.mainid;
      this.permission = this.$route.params.extra.permission;
      this.isFirstNode = this.$route.params.extra.isFirstNode;
    }
  },
};
</script>
<style scoped lang="less">
.selected {
  background-color: #e2f3e2 !important;
  color: #32ca72 !important;
}
.van-nav-bar {
  background: #ffffff;
  color: #323233;
  font-weight: bold;
  /*background: #456;*/
  /*color:white;*/
}
.van-nav-bar__title {
  font-weight: 800;
  color: #323233;
}
.van-nav-bar .van-icon {
  color: black;
}
.ha {
  border-bottom: 0.2px solid #dcdcdc;
}
.box {
  background-color: #fff;
}

.van-button {
  width: 100%;
}
#aaa {
  width: 100vw;
  height: 46px;
}
#add {
  position: fixed;
  top: 300px;
  right: 0;
}
.van-cell-group__title {
  color: #323233 !important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.van-cell {
  color: #969799 !important;
}
.van-tag--danger.van-tag--plain {
  color: rgb(131, 134, 131);
}
.detailcell {
  line-height: 1rem !important;
  border: 1px solid #dadae4;
  margin-bottom: 10px;
  background: #f7f8fa;
}
</style>